/* eslint-disable @typescript-eslint/naming-convention */
import styled from 'styled-components'
import { Image, Typography } from 'antd'
import { useCallback } from 'react'
import { SvgIcon } from '../svg-icon'
import { t } from '@/i18n'
interface TemplateItemProps {
  active: boolean
  cover: string
  name: string
  type: string | number
  sender?: string
  subject?: string
  autocommit?: number
  title?: string
  redirect?: string
  optimum?: boolean
  template_type: number
  onClick?: () => void
  accessory_type?: string
}
export const TemplateItem = (props: TemplateItemProps) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const {
    cover,
    name,
    type,
    active,
    onClick,
    title,
    sender,
    subject,
    template_type,
    optimum,
    autocommit,
    redirect,
    accessory_type,
  } = props

  const Images = useCallback(() => {
    if (title === '邮件模板') {
      return (
        <>
          {template_type === 1 && (
            <div className="email-image">
              <Image
                // preview={false}
                width={75}
                height={100}
                fallback={`${
                  process.env.NODE_ENV === 'dev' ? '/api' : ''
                }/static/default/phishPage.png`}
                src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${cover.replace(
                  /\./g,
                  '_100x100.',
                )}`}
                preview={false}
                className="template-img"
              />
            </div>
          )}
          {(template_type === 2 || template_type === 3) && type === 1 && (
            <SvgIcon name={'phishing-link'} width={'64px'} height={'64px'} />
          )}
          {(template_type === 2 || template_type === 3) && type === 0 && (
            <SvgIcon name={'phishing-task-accessory'} width={'64px'} height={'64px'} />
          )}
        </>
      )
    } else if (title === '钓鱼页模板') {
      return (
        <>
          {template_type === 1 && (
            <div className="email-image">
              <Image
                // preview={false}
                width={75}
                height={100}
                fallback={`${
                  process.env.NODE_ENV === 'dev' ? '/api' : ''
                }/static/default/phishPage.png`}
                src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${cover.replace(
                  /\./g,
                  '_100x100.',
                )}`}
                preview={false}
                className="template-img"
              />
            </div>
          )}
          {(template_type === 2 || template_type === 3) && autocommit === 1 && (
            <SvgIcon name={'phishing-page-information'} width={'64px'} height={'64px'} />
          )}
          {(template_type === 2 || template_type === 3) && autocommit === 2 && (
            <SvgIcon name={'phishing-page'} width={'64px'} height={'64px'} />
          )}
        </>
      )
    } else if (title === '附件模板') {
      return (
        <>
          {type === 1 && <SvgIcon name={'exe'} width={'64px'} height={'64px'} />}
          {type === 2 && <SvgIcon name={'doc-x'} width={'64px'} height={'64px'} />}
          {type === 3 && <SvgIcon name={'xls-x'} width={'64px'} height={'64px'} />}
          {type === 4 && <SvgIcon name={'ppt-x'} width={'64px'} height={'64px'} />}
          {type === 5 && <SvgIcon name={'pdf'} width={'64px'} height={'64px'} />}
          {type === 6 && <SvgIcon name={'rtf'} width={'64px'} height={'64px'} />}
        </>
      )
    }
    return <div>{t('参数错误')}</div>
  }, [title])
  return (
    <TemplateItemContainer
      active={active}
      istitle={title === '邮件模板'}
      onClick={() => {
        onClick?.()
      }}
    >
      <div className="content">
        {optimum && <div className="su-content">{t('最佳匹配')}</div>}
        <Images />
        <div style={{ marginLeft: '10px', width: '70%' }}>
          <div
            className={title === '邮件模板' ? 'title' : 'title-phishing'}
            style={{ fontWeight: '600', marginTop: '4px', color: '#333' }}
          >
            {name}
          </div>
          {subject && (
            <div className={title === '邮件模板' ? 'title' : 'title-phishing'}>
              {t('邮件主题：')}
              {subject}
            </div>
          )}
          {sender && (
            <div className={title === '邮件模板' ? 'title' : 'title-phishing'}>
              {t('发件人：')}
              {sender}
            </div>
          )}
          {/* {redirect && (
             <div className={title === '邮件模板' ? 'title' : 'title-phishing'}>
               重定向：{redirect}
             </div>
            )} */}
          {title === '邮件模板' && (
            <div
              className={title === '邮件模板' ? 'title' : 'title-phishing'}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <span>{t('邮件类型:')} </span>
              {!autocommit && (
                <div className={type === 0 ? 'color-fj' : 'color-lj'}>
                  {type === 0 ? t('恶意附件') : t('钓鱼链接')}
                </div>
              )}
            </div>
          )}
          {title === '钓鱼页模板' && (
            <div className="title-phishing" style={{ display: 'flex', alignItems: 'center' }}>
              <span>{t('钓鱼页类型：')}</span>
              {autocommit === 1 && <div className="phishing">{t('钓鱼页+信息收集')}</div>}
              {autocommit === 2 && <div className="gather">{t('钓鱼页')}</div>}
            </div>
          )}
          {title === '附件模板' && (
            <div className="title-phishing" style={{ display: 'flex', alignItems: 'flex-start' }}>
              <span>{t('附件：')}</span>
              {/* <div className="text">{accessory_type}</div> */}
              <Typography.Text
                style={{ whiteSpace: 'pre-wrap', width: '300px' }}
                ellipsis={{ tooltip: true }}
              >
                {accessory_type}
              </Typography.Text>
            </div>
          )}
          {title === '附件模板' && (
            <div className="title-phishing" style={{ display: 'flex', alignItems: 'center' }}>
              <span>{t('附件类型：')}</span>
              {type === 1 && <span className="accessory-exe">EXE</span>}
              {type === 2 && <span className="accessory-doc">DOC/X</span>}
              {type === 3 && <span className="accessory-xls">XLS/X</span>}
              {type === 4 && <span className="accessory-ppt">PPT/X</span>}
              {type === 5 && <span className="accessory-pdf">PDF</span>}
              {type === 6 && <span className="accessory-rtf">RTF</span>}
            </div>
          )}
        </div>
        {template_type === 1 ? (
          <div className="internally">{t('系统内置')}</div>
        ) : template_type === 2 ? (
          <div className="custom">{t('自定义')}</div>
        ) : (
          <div className="ai">{t('AI生成')}</div>
        )}
      </div>
    </TemplateItemContainer>
  )
}

interface TemplateItemContainerProps {
  active?: boolean
  istitle: boolean
}
const TemplateItemContainer = styled.div<TemplateItemContainerProps>`
  position: relative;
  height: 136px;
  box-shadow: ${props => (props.active ? '0px 2px 8px 0px rgba(0, 0, 0, 0.15)' : 'unset')};
  /* margin-left: 10px;
  margin-right: 10px; */
  transition: all 0.3s;
  &:nth-child(3n) {
    margin-right: 0;
  }
  .su-content {
    position: absolute;
    top: 10px;
    left: -26px;
    font-size: 12px;
    background-color: red;
    color: #fff;
    width: 100px;
    text-align: center;
    z-index: 99;
    transform: rotate(330deg);
  }
  .email_type {
    height: 22px;
    line-height: 20px;
    border-radius: 4px;
    font-size: 10px;
    padding: 0 6px;
    overflow: hidden;
  }
  .color-fj {
    background: #f5d9da;
    padding: 4px 8px;
    color: #d0011c;
    display: inline-block;
    border-radius: 4px;
    font-size: 12px;
    margin-left: 10px;
  }
  .color-lj {
    background: #ebe9ff;
    color: #645aff;
    padding: 4px 8px;
    font-size: 12px;
    display: inline-block;
    border-radius: 4px;
    margin-left: 10px;
  }
  .section {
    height: 12px;
  }
  cursor: pointer;
  .content {
    height: 100%;
    padding: 18px 14px 11px;
    position: relative;
    width: 100%;
    z-index: 3;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: ${props => (props.istitle ? '' : 'center')};
    .template-img {
      width: 100%;
    }
    .internally {
      position: absolute;
      right: -1px;
      top: -1px;
      padding: 3px 6px;
      font-size: 12px;
      background: #558492;
      color: #fff;
      border-radius: 0px 8px 0px 8px;
    }
    .custom {
      position: absolute;
      right: -1px;
      top: -1px;
      padding: 3px 6px;
      font-size: 12px;
      background: #ed787e;
      color: #fff;
      border-radius: 0px 8px 0px 8px;
    }
    .ai {
      position: absolute;
      right: -1px;
      top: -1px;
      padding: 3px 6px;
      font-size: 12px;
      background: linear-gradient(19deg, #2090a8 0%, #4f4fae 100%);
      color: #fff;
      border-radius: 0px 8px 0px 8px;
    }
    .title {
      font-size: 14px;
      overflow: hidden;
      margin-bottom: 8px;
      color: #666;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .title-phishing {
      font-size: 14px;
      overflow: hidden;
      margin-bottom: 16px;
      color: #666;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tag {
      font-size: 12px;
      color: #666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  &:hover {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
    &:after {
      top: -2px;
      bottom: -2px;
      left: -2px;
      right: -2px;
      background: #576cd1;
    }
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    background-color: #fff;
    top: 0px;
    border-radius: 8px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background-color: #fff;
    z-index: 2;
  }
  &:after {
    content: '';
    transition: all 0.2s;
    display: block;
    position: absolute;
    top: ${props => (props.active ? ' -2px' : ' -1px')};
    bottom: ${props => (props.active ? ' -2px' : ' -1px')};
    left: ${props => (props.active ? ' -2px' : ' -1px')};
    right: ${props => (props.active ? ' -2px' : ' -1px')};
    /* background: -moz-linear-gradient(to right,rgba(83, 171, 255, 0.2), rgba(93, 60, 211, 0.2),rgba(41, 115, 255, 0.2)); */
    background: ${props => (props.active ? '#576CD1' : '#D9D9D9')};
    border-radius: 8px;
    z-index: 1;
  }
  .gather {
    padding: 4px 8px;
    background: #e0f2f2;
    border-radius: 4px;
    color: #65bdc0;
    font-size: 12px;
    margin-left: 10px;
  }
  .phishing {
    padding: 4px 8px;
    background: #d5e4ff;
    border-radius: 4px;
    color: #2973ff;
    font-size: 12px;
  }
  .text {
    overflow: hidden;
    color: #666;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .accessory-exe {
    padding: 4px 8px;
    background: rgba(179, 89, 59, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #b3593b;
  }
  .accessory-doc {
    padding: 4px 8px;
    background: rgba(0, 55, 113, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #003771;
  }
  .accessory-xls {
    padding: 4px 8px;
    background: rgba(97, 164, 157, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #61a49d;
  }
  .accessory-ppt {
    padding: 4px 8px;
    background: rgba(66, 106, 103, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #426a67;
  }
  .accessory-pdf {
    padding: 4px 8px;
    background: #f5d9da;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #d38788;
  }
  .accessory-rtf {
    padding: 4px 8px;
    background: rgba(222, 118, 87, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #de7657;
  }
  .email-image {
    width: 75px;
    height: 100px;
    border-radius: 6px;
    overflow: hidden;
  }
`
